export default __webpack_public_path__ + "static/media/fundo_rotate.507912ac.svg";